import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("section", { class: "w-full flex justify-center items-center bg-gray-100 py-20 px-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col sm:grid sm:grid-cols-3 sm:items-start sm:max-w-6xl sm:gap-4" }, [
    /*#__PURE__*/_createElementVNode("div", {
      "data-aos": "fade-right",
      class: "flex flex-col items-center"
    }, [
      /*#__PURE__*/_createElementVNode("svg", {
        class: "fill-sky-700 h-10 w-1cd 0 flex-no-shrink",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        fill: "#000000",
        version: "1.1",
        id: "Icons",
        viewBox: "0 0 32 32",
        "xml:space": "preserve"
      }, [
        /*#__PURE__*/_createElementVNode("path", { d: "M30.9,5.6C30.8,5.2,30.4,5,30,5h-3V2c0-0.4-0.2-0.8-0.6-0.9C26,0.9,25.6,1,25.3,1.3l-4,4C21.1,5.5,21,5.7,21,6v3.6l-5.7,5.7  c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l5.7-5.7H26c0.3,0,0.5-0.1,0.7-0.3l4-4C31,6.4,31.1,6,30.9,5.6z" }),
        /*#__PURE__*/_createElementVNode("path", { d: "M18.1,18.1C17.6,18.7,16.8,19,16,19s-1.6-0.3-2.1-0.9c-1.2-1.2-1.2-3.1,0-4.2l2.8-2.8C16.5,11,16.2,11,16,11  c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5c0-0.2,0-0.5-0.1-0.7L18.1,18.1z" }),
        /*#__PURE__*/_createElementVNode("path", { d: "M28.1,12.1C27.6,12.7,26.8,13,26,13h-2.8l-0.7,0.7c0.3,0.7,0.4,1.5,0.4,2.3c0,3.9-3.1,7-7,7s-7-3.1-7-7s3.1-7,7-7  c0.8,0,1.6,0.2,2.3,0.4L19,8.8V6c0-0.8,0.3-1.6,0.9-2.1l1-1C19.3,2.3,17.7,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14  c0-1.7-0.3-3.3-0.9-4.9L28.1,12.1z" })
      ]),
      /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-sky-700 text-xl font-bold" }, "MISSÃO"),
      /*#__PURE__*/_createElementVNode("p", { class: "text-center text-sm text-gray-700" }, " Proporcionar os melhores produtos e serviços de piscinas para o lazer e relaxamento de nossos clientes, oferecendo uma ampla variedade de opções de alta qualidade e durabilidade, além de uma equipe de profissionais experientes para ajudar na escolha e instalação da piscina.")
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      "data-aos": "fade-right",
      "data-aos-delay": "200",
      class: "mt-6 flex flex-col items-center sm:mt-0"
    }, [
      /*#__PURE__*/_createElementVNode("svg", {
        class: "fill-sky-700 h-10 w-1cd 0 flex-no-shrink",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#000000",
        viewBox: "0 0 16 16"
      }, [
        /*#__PURE__*/_createElementVNode("path", { d: "m15.71 7.77c-1.22-3.19-4.3-5.29-7.71-5.26-3.44-.07-6.54 2.04-7.72 5.27-.04.15-.04.3 0 .44 1.19 3.22 4.29 5.33 7.72 5.27 3.42.03 6.49-2.07 7.72-5.26.04-.15.04-.31-.01-.46zm-7.71 4.24c-2.7.1-5.18-1.51-6.2-4.01 1.01-2.51 3.49-4.11 6.2-4.01 2.69-.06 5.15 1.53 6.19 4.01-1.05 2.48-3.5 4.07-6.19 4.01zm0-6.66c-.18 0-.36.02-.53.06.26.35.4.77.4 1.21-.05 1.25-1.1 2.21-2.35 2.16-.01 0-.03 0-.04 0h-.07c.42 1.41 1.9 2.21 3.31 1.79s2.21-1.9 1.79-3.31c-.33-1.13-1.35-1.9-2.51-1.91z" })
      ]),
      /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-sky-700 text-xl font-bold" }, "VISÃO"),
      /*#__PURE__*/_createElementVNode("p", { class: "text-center text-sm text-gray-700" }, "Além de oferecer uma ampla variedade de opções de piscinas de alta qualidade e durabilidade, oferecendo um excelente atendimento ao cliente e uma garantia completa em todos os nossos produtos e serviços. ")
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      "data-aos": "fade-right",
      "data-aos-delay": "400",
      class: "mt-6 flex flex-col items-center sm:mt-0"
    }, [
      /*#__PURE__*/_createElementVNode("svg", {
        class: "fill-sky-700 h-10 w-1cd 0 flex-no-shrink",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        fill: "#000000",
        version: "1.1",
        id: "Capa_1",
        viewBox: "0 0 466.145 466.145",
        "xml:space": "preserve"
      }, [
        /*#__PURE__*/_createElementVNode("g", null, [
          /*#__PURE__*/_createElementVNode("g", null, [
            /*#__PURE__*/_createElementVNode("path", { d: "M293.094,213.681l-52.521,11.791v-61.727c-4.906,1.163-10.103,1.136-15-0.024v61.751l-61.205-13.741    c-0.085,2.543-0.455,5.064-1.13,7.506l9.808,9.815l47.862,10.746l-8.563,13.178c4.984,1.332,9.496,3.826,13.225,7.181    l7.503-11.548l30.146,46.391l22.853,11.557c0.611-0.373,1.24-0.707,1.873-1.039L245.236,239.8l53.172-11.938    C295.562,223.663,293.719,218.815,293.094,213.681z" }),
            /*#__PURE__*/_createElementVNode("path", { d: "M233.072,11.407L0,180.744l89.025,273.993h288.092l89.027-273.993L233.072,11.407z M358.686,414.38l-35.787-55.072    c-3.938,3.137-8.617,5.375-13.734,6.396l38.363,59.035H118.616l72.259-111.194c-4.663-2.095-8.742-5.261-11.918-9.189    l-71.5,110.026L37.341,198.585l62.65,14.065c-0.04-0.659-0.067-1.322-0.067-1.992c0-4.547,0.951-8.873,2.656-12.8l-57.369-12.88    L225.572,53.939v47.106c2.408-0.576,4.918-0.89,7.5-0.89c2.583,0,5.092,0.313,7.5,0.89V53.939l180.361,131.04l-65.254,14.65    c1.064,3.196,1.648,6.61,1.648,10.159c0,1.671-0.131,3.317-0.383,4.93l71.855-16.133L358.686,414.38z" }),
            /*#__PURE__*/_createElementVNode("path", { d: "M324.621,187.649c-4.266,0-8.254,1.21-11.643,3.301l-59.719-50.228c1.018-2.546,1.584-5.32,1.584-8.227    c0-12.263-9.977-22.24-22.241-22.24c-12.263,0-22.239,9.978-22.239,22.24c0,2.67,0.474,5.23,1.34,7.604l-66.771,52.799    c-3.701-2.75-8.281-4.38-13.236-4.38c-12.264,0-22.24,9.978-22.24,22.24c0,12.264,9.977,22.24,22.24,22.24    c3.173,0,6.19-0.673,8.924-1.875l43.081,43.127c-1.515,3.003-2.374,6.392-2.374,9.979c0,12.264,9.977,22.24,22.24,22.24    c6.106,0,11.646-2.476,15.669-6.475l61.149,30.919c-0.161,1.071-0.244,2.165-0.244,3.279c0,12.264,9.978,22.239,22.239,22.239    c12.264,0,22.24-9.977,22.24-22.239c0-8.425-4.709-15.771-11.633-19.543l14.807-82.753c10.766-1.545,19.066-10.824,19.066-22.01    C346.861,197.625,336.885,187.649,324.621,187.649z M299.207,312.185c-4.84,0.695-9.182,2.951-12.494,6.244l-61.149-30.92    c0.159-1.07,0.243-2.166,0.243-3.278c0-12.265-9.976-22.24-22.239-22.24c-3.58,0-6.964,0.854-9.964,2.365l-42.575-42.622    c1.848-3.24,2.908-6.985,2.908-10.975c0-2.221-0.331-4.364-0.939-6.39l67.398-53.296c3.507,2.313,7.702,3.663,12.207,3.663    c4.266,0,8.254-1.21,11.643-3.301l59.719,50.227c-1.018,2.547-1.584,5.321-1.584,8.228c0,8.424,4.709,15.77,11.635,19.543    L299.207,312.185z" })
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-sky-700 text-xl font-bold" }, "VALORES"),
      /*#__PURE__*/_createElementVNode("p", { class: "text-center text-sm text-gray-700" }, "Nossa loja tem uma ampla rede de distribuição e fornecedores confiáveis, garantindo assim a disponibilidade de todos os produtos e serviços que oferecemos. Além disso, contamos com um sistema de entrega eficiente e rápido, para que você receba sua piscina o mais breve possível.")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "waves bg-gray-100",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    viewBox: "0 24 150 28",
    preserveAspectRatio: "none",
    "shape-rendering": "auto"
  }, [
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("path", {
        id: "gentle-wave",
        d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
      })
    ]),
    /*#__PURE__*/_createElementVNode("g", { class: "parallax" }, [
      /*#__PURE__*/_createElementVNode("use", {
        "xlink:href": "#gentle-wave",
        x: "48",
        y: "0",
        fill: "rgba(19,189,212,0.7"
      }),
      /*#__PURE__*/_createElementVNode("use", {
        "xlink:href": "#gentle-wave",
        x: "48",
        y: "3",
        fill: "rgba(19,189,212,0.5)"
      }),
      /*#__PURE__*/_createElementVNode("use", {
        "xlink:href": "#gentle-wave",
        x: "48",
        y: "5",
        fill: "rgba(19,189,212,0.3)"
      }),
      /*#__PURE__*/_createElementVNode("use", {
        "xlink:href": "#gentle-wave",
        x: "48",
        y: "7",
        fill: "#13BDD4"
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}